// Staff and adult PIN hashes. Shared so the kiosk can check a PIN offline against the roster
// mirror with exactly the server's algorithm.
import { b64url, utf8 } from "./bytes.ts";

export async function hashPin(subjectId: string, pin: string): Promise<string> {
  const k = await crypto.subtle.importKey("raw", utf8(pin) as BufferSource, "PBKDF2", false, ["deriveBits"]);
  // The salt label predates the rename to Vavr and must not change: every stored PIN hash depends on it.
  const bits = await crypto.subtle.deriveBits({ name: "PBKDF2", hash: "SHA-256", salt: utf8(`pickmeup-pin:${subjectId}`) as BufferSource, iterations: 20_000 }, k, 256);
  return b64url(bits);
}

export async function checkPin(subjectId: string, pin: string, stored: string | null): Promise<boolean> {
  if (!stored || !/^\d{4}$/.test(pin)) return false;
  return (await hashPin(subjectId, pin)) === stored;
}
